import TintucPageApi from "./TintucPageApi";
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

function Header() {
  const [data, setData] = useState([]);

  useEffect(() => {
    TintucPageApi.getAllType(16).then((data) => {
      setData(data); // Update state with the resolved data
    }).catch((error) => {
      console.error("Failed to fetch data:", error); // Handle errors
    });
  }, []);

  return (
    <nav className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        {/* Brand and toggle get grouped for better mobile display */}
        <div className="navbar-header">
          <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1">
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar" />
            <span className="icon-bar" />
            <span className="icon-bar" />
          </button>
          <a className="navbar-brand" href="/"> <img className="logoAnimation" src={require("./Upload/images/tab/tab1.png")} /> <span>LINH QUY PHÁP ẤN</span> </a>
        </div>
        {/* Collect the nav links, forms, and other content for toggling */}
        <div className="collapse navbar-collapse menuHeader" id="bs-example-navbar-collapse-1">
          <form action="/Search" className="navbar-form navbar-right formSearchMenu" method="get" role="search">        <div className="input-group">
            <input className="form-control" placeholder="Tìm kiếm" name="keywords" id="keywords" type="text" />
            <div className="input-group-btn">
              <button className="btn btn-default" type="submit">
                <i className="glyphicon glyphicon-search"> </i>
              </button>
            </div>
          </div>
          </form>
          <ul className="nav navbar-nav  navbar-right">
            <li>
              <a href="/"> TRANG CHỦ</a>
            </li>
            <li>
              <a href="/video"> VIDEO</a>
            </li>
            <li>
              <a href="/audio"> AUDIO</a>
            </li>
            <li>
              <a href="/tin-tuc"> TIN TỨC</a>
              <ul className="dropdown-menu">
                {data?.map((item, index) => (
                  <div>
                    <li>
                      <a href={`/tin-tuc?title=${item.Name}&catId=${item.Id}`}>{item.Name}</a>
                    </li>
                  </div>
                ))}
              </ul>
            </li>
            <li>
              <a href="/hinh-anh"> HÌNH ẢNH</a>
            </li>
            <li>
              <a href="/bai-giang-pho-thong"> Bài Giảng Phổ Thông</a>
            </li>
            <li>
              <a href="/kinh-sach"> KINH SÁCH</a>
            </li>
            <li>
              <a href="/contact"> Liên hệ</a>
            </li>
          </ul>
        </div>{/* /.navbar-collapse */}
      </div>{/* /.container-fluid */}
    </nav>
  );
}

export default Header;
